// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"273d27e8","522":"698d2878","872":"cc002e68"}[chunkId] + ".chunk.js";
};